/**************************************************************************************************/
/*   File: /src/app/shared/models/dossier.status.ts                                               */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Mon Apr 01 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { DossierStatusEnum } from '../enums/dossier.status.enum';
import { User } from './user';

/**
 * The dossier status
 */
export class DossierStatus {
    /**
     * The status
     */
    status: DossierStatusEnum;
    /**
     * The transition date
     */
    transitionDate: Date;
    /**
     * The description
     */
    description: string;
    /**
     * The user
     */
    user?: User;
}